import React from "react";
import { portfolioData } from "../data/portfolioData";

const navItems = [
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "experience", label: "Experience" },
  { id: "projects", label: "Projects" },
  { id: "contact", label: "Contact" },
];

const Navbar = () => {
  const handleScroll = (event, id) => {
    event.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header className="sticky top-0 z-40 border-b border-slate-700/70 bg-slate-950/80 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
        <a
          href="#hero"
          onClick={(event) => handleScroll(event, "hero")}
          className="text-lg font-bold tracking-tight text-slate-100"
        >
          {portfolioData.name.split(" ")[0]}
          <span className="text-cyan-300">.Dev</span>
        </a>

        <div className="hidden items-center gap-6 text-sm text-slate-300 md:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(event) => handleScroll(event, item.id)}
              className="transition hover:text-cyan-300"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(event) => handleScroll(event, "contact")}
            className="rounded-full border border-cyan-300/40 px-4 py-1.5 text-cyan-200 transition hover:border-cyan-200 hover:bg-cyan-300/10"
          >
            Hire Me
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
